import { render } from "./ErrorElement.vue?vue&type=template&id=4dc4504e"
import script from "./ErrorElement.vue?vue&type=script&lang=js"
export * from "./ErrorElement.vue?vue&type=script&lang=js"

import "./ErrorElement.vue?vue&type=style&index=0&id=4dc4504e&lang=css"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__